export const Mask = (str, paramsOptions) => {
  const defaultOptions = {
    start: 1,
    end: 0,
    symbol: "*"
  }
  let options = Object.assign(defaultOptions, paramsOptions)
  if (!options) { options = { start: 1, end: 0, symbol: "*" } }
  if (options.start < 0 || options.end < 0) { return "" }
  
  const len = str.length
  
  let s = ""
  for (let i = 0; i < options.start && i < len; i++) { s += str.charAt(i) }

  let e = ""
  for (let i = len - 1; i >= 0 && i >= len - options.end; i--) { e = str.charAt(i) + e }

  const sym = options.symbol.repeat(Math.max(options.middle || (len - options.start - options.end), 0))
  
  return s + sym + e
}

/**
 * @description: 姓名脱敏
 * @param {string} name
 * @return {*}
 * @author: syx
 */
export const MaskName = (name, symbol = "*") => {
  if (!name) { return "" }
  
  const len = name.length
  
  if (len === 1) { return name }
  
  const s = name.charAt(0)
  const e = name.charAt(len - 1)
  
  return Mask(name.substring(1, len - 1), { start: 1, symbol}) ? `${s}*${e}` : `${s}${e}`
}

/**
 * @description: 身份证号脱敏
 * @param {string} idcard
 * @return {*}
 * @author: syx
 */
export const MaskIdCard = (idcard, symbol = "*") => {
  if (!idcard) { return "" }
   
  return Mask(idcard, { start: 4, end: 4, symbol })
}

/**
 * @description: 
 * @param {string} phone
 * @return {*}
 * @author: syx
 */
export const MaskPhone = (phone, symbol = "*") => {
  if (!phone) { return "" }
  return Mask(String(phone), { start: 3, end: 4, symbol})
}

export const MaskAddress = (address, symbol = "*") => {
  if (!address) { return "" }
  
  const parts = address.trim().split(/\s+/)
  const len = parts.length
  
  let res = ""
  
  for (let i = 0; i < len; i++) {
    if (/^[\u4e00-\u9fa5]+$/.test(parts[i])) {
      res += Mask(parts[i], { start: 1, symbol })
    } else {
      res += Mask(parts[i], { start: 2, symbol })
    }
    
    if (i < len - 1) { res += " " }
  }
  
  return res
}

const maskTypeObj = {
  mobile: MaskPhone,
  name: MaskName,
  address: MaskAddress,
  idCard: MaskIdCard
}

export const Desensitization = (str, options) => {
  // none类型则直接返回原数据
  if (options.maskType === "none") {
    return str
  }
  const defaultOptions = {
    start: 1, // 从前往后保留的位数，默认为 1
    end: 0, // 从后往前保留的位数，默认为 0
    symbol: "*", // 替换的字符，默认为 *
    defaultVal: "",
    maskType: ""
  }

  Object.assign(defaultOptions, options)
  // 没值返回默认值
  if (!str) { return defaultOptions.defaultVal }
  // 有传类型时，返回默认类型
  if (defaultOptions.maskType) {
    return maskTypeObj[defaultOptions.maskType](str, defaultOptions.symbol)
  }
  const maskOptions = {
    start: defaultOptions.start,
    end: defaultOptions.end,
    middle: defaultOptions.middle,
    symbol: defaultOptions.symbol
  }
  return Mask(str, maskOptions)
}